import React from "react";
import PropTypes from "prop-types";

import styles from "./MembershipInfoCard.module.css";
import History from "shared/@hooks/LookupByIBO/Details/Membership/History";

/**
 * Interactive component.
 * Displays IBO membership information in a card format.
 */
export function MembershipInfoCard({ membership, onClick, showHistory }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Membership</div>

        <div className={styles.hr} />
        {/* <button type="button" className={styles.button} onClick={onClick}>
          {showHistory ? "Hide History" : "Show History"}
        </button> */}
      </div>

      <div className={styles.content}>
        <div className={styles.spacer}>
          <div className={styles.title}>Membership Status</div>
          <div>{membership.status}</div>
        </div>
        <div>
          <div className={styles.title}>Current Membership</div>
          <div>{membership.current}</div>
        </div>
        <div>
          <div className={styles.title}>Pending Membership</div>
          <div>{membership.pending}</div>
        </div>
        <div>
          <div className={styles.title}>Next Billing Date</div>
          <div>{membership.billingDate}</div>
        </div>
      </div>

      {showHistory && <History iboNumber={membership.number} />}
    </div>
  );
}

MembershipInfoCard.propTypes = {
  /**
   * Object with membership details.
   */
  membership: PropTypes.shape({
    status: PropTypes.string,
    pending: PropTypes.string,
    billingDate: PropTypes.string,
    username: PropTypes.string,
  }),
  /**
   * Function called when 'show history' is clicked.
   */
  onClick: PropTypes.func,
};
